import React, { useState } from "react";
import { UploadOutlined } from "@ant-design/icons";
import { Button, message, Upload, Image } from "antd";
import axios from "axios";
import { URL } from "../helper/Mainurl";

const ImageTest = () => {
  const [fileUrl, setFileUrl] = useState("");
  const token = localStorage.getItem("authToken");

  const handleUpload = async ({ file }) => {
    if (file.type.startsWith("image/")) {
        const reader = new FileReader();
    
        reader.onload = async () => {
          const base64String = reader.result; // Keep full Data URL format
    
          const payload = {
            invite_file: base64String, // Send full Data URL format
          };
    
          try {
            const response = await fetch(`${URL}/v1/invite-capture/update`, {
                  method: "POST",
                  headers: {
                    Accept: "application/json",
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                    "Cache-Control": "no-cache",
                  },
                  body: JSON.stringify(payload),
                });
    
            if (response.status === 200) {
              message.success("Image uploaded successfully!");
              setFileUrl(response.data.fileUrl);
            } else {
              message.error("Upload failed!");
            }
          } catch (error) {
            console.error("Upload error:", error);
            message.error("Something went wrong!");
          }
        };
    
        reader.readAsDataURL(file); // Keep full Base64 Data URL
      } 
      
if (file.type === "application/pdf") {
      // Send PDF as File (multipart/form-data)
      const formData = new FormData();
      formData.append("invite_file", file);

      try {
        const response = await axios.post(
          `${URL}/v1/invite-capture/upload-invite`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.status === 200) {
          message.success("PDF uploaded successfully!");
          setFileUrl(response.data.fileUrl);
        } else {
          message.error("Upload failed!");
        }
      } catch (error) {
        console.error("Upload error:", error);
        message.error("Something went wrong!");
      }
    } else {
      message.error("Only images and PDFs are allowed!");
    }
  };

  return (
    <div>
      <Upload 
        customRequest={handleUpload} 
        showUploadList={false} 
        accept="image/*,application/pdf"
      >
        <Button icon={<UploadOutlined />}>Upload Image or PDF</Button>
      </Upload>

      {fileUrl && (
        <div>
          <p>Uploaded File:</p>
          <a href={fileUrl} target="_blank" rel="noopener noreferrer">
            Open File
          </a>
        </div>
      )}
    </div>
  );
};

export default ImageTest;
